import { client } from '@atlassian/rovo-content-bridge-api';
export var JIRA_SMART_CREATE_MODAL_CLIENT_ID = client('jira-smart-create-modal');